import { TgMailing } from "@/modules/telegram/interfaces"

/**
 * RTK Query отдаёт не «голые» HTTP-коды:
 *  - текстовый/HTML-ответ (413 body-parser, 502/504 ingress) → { status: "PARSING_ERROR", originalStatus };
 *  - сетевая ошибка → "FETCH_ERROR"; таймаут (FetchArgs.timeout, §Task 1) → "TIMEOUT_ERROR".
 */
export type ClassifyResult =
  | { type: "network" }
  | { type: "http"; status: number; data: unknown }

export const classifyError = (error: unknown): ClassifyResult => {
  const e = error as
    | {
        status?: unknown
        originalStatus?: number
        data?: unknown
        error?: unknown
      }
    | undefined
  if (e && typeof e === "object" && "status" in e) {
    if (e.status === "FETCH_ERROR" || e.status === "TIMEOUT_ERROR")
      return { type: "network" }
    if (e.status === "PARSING_ERROR") {
      return {
        type: "http",
        status: e.originalStatus ?? 0,
        data: e.data ?? e.error,
      }
    }
    if (typeof e.status === "number")
      return { type: "http", status: e.status, data: e.data }
  }
  return { type: "network" }
}

export const parseConflict = (
  data: unknown,
): TgMailing.PagedEnqueueConflict | null => {
  if (data && typeof data === "object" && "conflict" in data) {
    return data as TgMailing.PagedEnqueueConflict
  }
  return null
}

export const isStuckInvariant = (data: unknown): boolean => {
  const message = (data as { message?: unknown } | undefined)?.message
  return typeof message === "string" && message.includes("Mailing stuck")
}
